import { Apollo } from 'src/gql/generated';

import type { GoverningDocumentsSubset } from './governing-document-sources';

interface UseGoverningDocumentsResult {
  governingDocuments: GoverningDocumentsSubset | null;
  loading: boolean;
}

/**
 * Lazily loads an ExtractionJob's Governing Documents through its own minimal
 * query, keeping them off the report grid's high-fanout row query. Callers gate
 * `skip` on the popover being open, so only an opened cell costs a request.
 * Reruns and edits replace the answer without writing `governingDocuments` back
 * to the cache, so a reopened popover shows cached members and refetches.
 */
export function useGoverningDocuments(
  jobId: UUID | null | undefined,
  options: { skip: boolean }
): UseGoverningDocumentsResult {
  const { data, loading } = Apollo.useGetExtractionJobGoverningDocumentsQuery({
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: options.skip || !jobId,
    variables: { id: jobId ?? '' },
  });

  return {
    governingDocuments: data?.extractionJob.governingDocuments ?? null,
    loading,
  };
}
